import { useEffect } from 'react';

interface AddToHomeScreenOptions {
  appName?: string;
  appIconUrl?: string;
  assetUrl?: string;
  displayOptions?: {
    showMobile?: boolean;
    showDesktop?: boolean;
  };
  maxDisplayCount?: number;
  allowClose?: boolean;
  showArrow?: boolean;
}

interface AddToHomeScreenInstance {
  show: (language?: string) => void;
  hide: () => void;
}

declare global {
  interface Window {
    AddToHomeScreenInstance: AddToHomeScreenInstance;
    AddToHomeScreen: (options: AddToHomeScreenOptions) => AddToHomeScreenInstance;
  }
}

export function AddToHomescreen() {
  useEffect(() => {
    // Initialize add-to-homescreen with "calling UI later" approach
    if (window.AddToHomeScreen) {
      window.AddToHomeScreenInstance = window.AddToHomeScreen({
        appName: 'CO2 Snowboarding',
        appIconUrl: '/icons/apple-touch-icon.png',
        assetUrl: 'https://cdn.jsdelivr.net/gh/philfung/add-to-homescreen@3.4/dist/assets/img/',
        displayOptions: {
          showMobile: true,
          showDesktop: false
        },
        // Important: Set maxDisplayCount to 0 so it never shows automatically
        maxDisplayCount: 0,
        allowClose: true,
        showArrow: true
      });
    }
  }, []);

  return null; // This component doesn't render anything
}